export enum NodeType {
  BaseCondition = "baseCondition",
  LogicalConnector = "logicalConnector",
}
